import React from 'react';

// Routes Context
export const CurrentUserContext = React.createContext();
